import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/var/www/aiview-score/dashboard/node_modules/next/dist/client/app-dir/link.js");
